module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/point04_05_activity-3d675c35ced3b7964e63489c816c87cf.jpg";